import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { products } from "../data/products";
import "../styles/Productdetailed.css";
import TestimonialSlider from "../Page-section/Home/TestimonialSlider";
import Productsections from "../Page-section/Home/Productsections";
import Ingredients from "../Page-section/Home/madhuhem-Ingredients";
import CertificationSection from "../Page-section/Home/certification";
import ConsumeSection from "../Page-section/Home/ConsumeSection";
// import { Link } from "react-router-dom";
import icon1 from "../assets/images/icon1.svg";
import icon2 from "../assets/images/icon2.svg";
import icon3 from "../assets/images/icon3.svg";
import icon4 from "../assets/images/icon4.svg";

const ProductDetails = () => {
  const { slug } = useParams();
  const product = products.find((item) => item.slug === slug);

  const [qty, setQty] = useState(1);
  const [activeImage, setActiveImage] = useState(
    product?.images?.[0] || product?.img,
  );

  if (!product) return <h2>Product Not Found</h2>;

  return (
    <>
      {/* <div className="bannedr">
        <div className="banner-overlay">
          <h1>{product.name}</h1>
          <p className="breadcrumb">
            <span>
              <Link to="/">🏠 Home</Link>
            </span>
            {" / "}
            <span>{product.name}</span>
          </p>
        </div>
      </div> */}
      <section className="product-details">
        <div className="product-details-wrapper">
          <div className="product-image">
            <div className="main-image">
              <img src={activeImage} alt={product.name} />
            </div>
            <div className="thumbnail-row">
              {product.images.slice(0, 3).map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt="thumb"
                  className={`thumbnail ${activeImage === img ? "active" : ""}`}
                  onClick={() => setActiveImage(img)}
                />
              ))}
            </div>
          </div>
          <div className="product-content">
            <h1>{product.name}</h1>

            <div className="rating">
              <span className="stars">★★★★★</span>
              <span className="reviews">(249)</span>
            </div>

            <p className="description">{product.description}</p>

            <div className="features">
              <div className="feature">
                <img src={icon1} alt="Natural" />
                <span>Promotes Healthy Digestion*</span>
              </div>
              <div className="feature">
                <img src={icon3} alt="Fast Relief" />
                <span>Improves Heart Health*</span>
              </div>
              <div className="feature">
                <img src={icon2} alt="Safe" />
                <span>Promotes Mobility & Flexibility*</span>
              </div>
              <div className="feature">
                <img src={icon4} alt="Ayurvedic" />
                <span>Balances Sugar Levels*</span>
              </div>
            </div>

            <div className="price-row">
              <span className="new-pricee">Rs. {product.price}</span>
              <span className="old-pricee">Rs. {product.oldPrice}</span>
            </div>

            <div className="qty-row">
              <button onClick={() => qty > 1 && setQty(qty - 1)}>-</button>
              <span>{qty}</span>
              <button onClick={() => setQty(qty + 1)}>+</button>
            </div>

            <hr />

            <div className="action-buttons">
              <button className="buy-btn">BUY IT NOW</button>
            </div>
          </div>
        </div>

        {/* WhatsApp */}
        <a
          href="https://wa.me/919211710043"
          target="_blank"
          rel="noreferrer"
          className="whatsapp"
        >
          <i className="fab fa-whatsapp"></i>
        </a>
      </section>
      <Ingredients />
      <ConsumeSection />
      <CertificationSection />
      <TestimonialSlider />
      <Productsections />
    </>
  );
};

export default ProductDetails;
